import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance32ktucgjbbtjc as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance7qh971mvyfs7 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      n3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      x6q(writer, customScalarAdapters, value) {
        writer.q47('id');
        get_playerIdAdapter().o3z(writer, customScalarAdapters, value.n6o_1);
        writer.q47('name');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.o6o_1);
        writer.q47('email');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.p6o_1);
        var tmp = value.q6o_1;
        if (tmp instanceof Present()) {
          writer.q47('badge');
          present(nullable(Badge_ResponseAdapter_instance)).x40(writer, customScalarAdapters, value.q6o_1);
        }
        writer.q47('callSignAdjective');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.r6o_1);
        writer.q47('callSignNoun');
        get_StringAdapter().o3z(writer, customScalarAdapters, value.s6o_1);
        var tmp_0 = value.t6o_1;
        if (tmp_0 instanceof Present()) {
          writer.q47('imageURL');
          present(get_NullableStringAdapter()).x40(writer, customScalarAdapters, value.t6o_1);
        }
        var tmp_1 = value.u6o_1;
        if (tmp_1 instanceof Present()) {
          writer.q47('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).x40(writer, customScalarAdapters, value.u6o_1);
        }
        writer.q47('unvalidatedEmails');
        list(get_StringAdapter()).v40(writer, customScalarAdapters, value.v6o_1);
        writer.q47('pins');
        list(obj(PinInput_InputAdapter_instance)).v40(writer, customScalarAdapters, value.w6o_1);
      }
      o3z(writer, customScalarAdapters, value) {
        return this.x6q(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instancesqyq5n185zzu,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
